export const types = {
    CONNECT: 'CONNECT',
    CREATEUSER: 'CREATE-USER',
    DISCONNECT: 'DISCONNECT',
    DISABLEUSER: 'DISABLE-USER',
    ENABLEUSER: 'ENABLE-USER',
    DELETEUSER: 'DELETE-USER',
    UPDATEUSER: 'UPDATE-USER',
    REMOVEUSERFROMGROUP: 'REMOVE-USER-FROM-GROUP',
    ADDUSERTOGROUP: 'ADD-USER-TO-GROUP',
    ADDGROUP: 'ADD-GROUP',
    MOVEOBJECT: 'MOVE-OBJECT',
    UNLOCKUSER: 'UNLOCK-USER',
    LDAP: 'LDAP-QUERY',
    PASSWORD: 'PASSWORD-RESET',
    DELETECOMPUTER: 'DELETE-COMPUTER',
    CREATECONTACT: 'CREATE-CONTACT',
    UPDATECONTACT: 'UPDATE-CONTACT',
    DELETEOBJECT: 'DELETE-OBJECT',
    CREATEOBJECT: 'CREATE-OBJECT',
    UPDATEOBJECT: 'UPDATE-OBJECT',
    ADDOBJECTTOGROUP: 'ADD-OBJECT-TO-GROUP',
    REMOVEOBJECTFROMGROUP: 'REMOVE-OBJECT-FROM-GROUP'
};